<template lang="pug">
pr-wrapper#welcome.p-5.d-flex.flex-column(fs, bg="overlayFrom", bgo=".95", bgd="45")
  .macAddress(v-if="showMac") {{ getMac }}
  .header.row.no-gutters.align-items-stretch
    .col.col-auto.pr-5(v-if="config['app_logo_visibility.app_logo_visibility'] === '1'")
      img.logo(:src="logo")
    .col.col-auto.px-4.d-flex.align-items-center.border-left(v-if="isWeatherEnabled")
      pr-subtitle.mr-3.font-weight-light {{ isWeatherEnabled.current.temp }}{{ isWeatherEnabled.icon }}
      icon.fa-2x(:icon="isWeatherEnabled.current.icon") 
    .col.col-auto.pl-4.d-flex.align-items-left.justify-content-center.flex-column.border-left(v-if="isDatetimeEnabled")
      pr-text
        moment(format="hh:mm A, dddd", date, live)
      pr-text
        moment(format="DD MMMM YYYY", date, live)
  .content.flex-grow-1.d-flex.justify-content-center.flex-column
    .welcome-header.d-flex.align-items-center
      pr-text(size="xlarge", v-if="guest && showGuest") {{ $t("Welcome") }},
      pr-text(size="xlarge", v-else) {{ $t("Welcome") }}
      pr-badge.ml-3(
        v-if="config['is_room_number_showing.is_room_number_showing'] === '1'",
        arrow="left",
        v-html="hasTitle || $t('Room', [device.location])"
      )
    .welcome-name(v-if="guest && showGuest")
      pr-text(size="xlarge", v-if="guest")
        b {{ `${guest.name} ${guest.surname}` }}
      .guest-additional.border-bottom.border-top.font-italic.py-2.d-inline-block(v-if="guest && guest.additional") {{ guest.additional }}
    .welcome-text.mt-2
      pr-text(v-html="language.welcome")
    .welcome-buttons.mt-5(v-nv:scope="'welcome'")
      pr-button.themed.scale-sm.mr-4(v-nv.current, @nv-enter="setWelcome", outline) {{ $t("Continue") }}
      pr-button.themed.scale-sm(v-nv, @nv-enter="setLanguage", v-show="manyLanguage", outline) {{ language.NAME }}
        icon.ml-3(:icon="'fas sort'") 
  .footer
    .col.text-muted.small 
</template>

<script>
import { mapGetters, mapState } from "vuex"
export default {
  name: "welcome",
  computed: {
    hasTitle() {
      return _$.true(__.device.get("title")) && __.device.get("title")
    },
    showGuest() {
      return _$.true(__.device.config("show_guest_name.show_guest_name"))
    },
    showMac() {
      return _$.true(__.device.config("show_mac_address_at_home.show_mac_address_at_home"))
    },
    getMac() {
      return __.device.get("mac")
    },
    isWeatherEnabled() {
      return _$.true(__.device.config("services.weather")) && this.$store.state.rss.weather
    },
    isDatetimeEnabled() {
      return _$.true(__.device.config("services.datetime"))
    },
    logo() {
      return this.config["app_logo./uploads/"]
    },
    bgVideo() {
      return this.config["welcome.welcome_video"]
    },
    bgImage() {
      return this.config["welcome.welcome_image"]
    },
    manyLanguage() {
      return Object.values(this.languages || {}).length > 1 ? true : false
    },
    ...mapState(["config", "guest", "device", "languages"]),
    ...mapGetters(["language"])
  },
  async activated() {
    await __.platform.hasOpeningMedia("before_welcome")
    this.initBackground()
    _$.nav.changeScope("welcome")
  },
  mounted() {
    _$.nav.sync("welcome")
  },
  methods: {
    async setWelcome() {
      if (__.guest.get()) this.$store.state.guest.welcome = "1"
      sessionStorage.setItem("welcome", this.$store.getters.language.code)

      return __.guest
        .update()
        .then(() => __.platform.background())
        .then(() => __.platform.hasOpeningMedia("after_welcome"))
        .finally(() => __.platform.go(sessionStorage.getItem("homePage")))
    },
    async setLanguage() {
      _$.vue.$emit("worker", "language-selection")
    },
    initBackground() {
      if (this.bgImage) __.platform.background(this.bgImage, this.bgVideo)
      else if (this.bgVideo) __.media.play(this.bgVideo, true)
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  .logo {
    max-height: 80px;
  }
}

.content {
  #welcome {
    .themed {
      transform-origin: left;
    }
  }
}
.macAddress {
  position: absolute;
  bottom: 5px;
  z-index: 10;
  right: 50px;
  color: white;
}

.welcome-text {
  width: 50%;
}
</style>
